import { useState, useEffect } from "react";
import "./style.css";
import api from "../../services/api.js";
import { useAppContext } from '../../context/AppContext.js';

function Configuracao() {
    const [codparametro, setcodparametro] = useState(0);
    const [qtdefeedback, setqtdefeedback] = useState(0);
    const [valorcoinfeedbackpositivo, setvalorcoinfeedbackpositivo] = useState(0);
    const [valorcoinfeedbacknegativo, setvalorcoinfeedbacknegativo] = useState(0);
    const [valorcoinrankingconcluido, setvalorcoinrankingconcluido] = useState(0);
    const [valorcoinrankingconforme, setvalorcoinrankingconforme] = useState(0);
    const [valorcoinrankingprazo, setvalorcoinrankingprazo] = useState(0);
    const [valorcoinrankingavaliacao, setvalorcoinrankingavaliacao] = useState(0);
    const [qtdepremicaorankingconcluido, setqtdepremicaorankingconcluido] = useState(0);
    const [qtdepremicaorankingconforme, setqtdepremicaorankingconforme] = useState(0);
    const [qtdepremicaorankingprazo, setqtdepremicaorankingprazo] = useState(0);
    const [qtdepremicaorankingavaliacao, setqtdepremicaorankingavaliacao] = useState(0);
    const [valorpremiacaosetor, setvalorpremiacaosetor] = useState(0);
    const [valorpremiacaofuncao, setvalorpremiacaofuncao] = useState(0);
    const [valorpremiacaoequipe, setvalorpremiacaoequipe] = useState(0);
    const [verificaorcamento, setverificaorcamento] = useState("N");

    const { codassinante, selectedCompany, accessKey } = useAppContext();

    function ListarParametro() {
        api
            .get("/v1/parametro", {
                params: {
                    busca: "",
                    codassinante: codassinante,
                    codempresa: selectedCompany
                },
                headers: {
                    Authorization: `Bearer ${accessKey}`,
                },
            })
            .then(function (response) {
                setcodparametro(response.data.codparametro);
                setqtdefeedback(response.data.qtdefeedback);
                setvalorcoinfeedbackpositivo(response.data.valorcoinfeedbackpositivo);
                setvalorcoinfeedbacknegativo(response.data.valorcoinfeedbacknegativo);
                setvalorcoinrankingconcluido(response.data.valorcoinrankingconcluido);
                setvalorcoinrankingconforme(response.data.valorcoinrankingconforme);
                setvalorcoinrankingprazo(response.data.valorcoinrankingprazo);
                setvalorcoinrankingavaliacao(response.data.valorcoinrankingavaliacao);
                setqtdepremicaorankingconcluido(response.data.qtdepremicaorankingconcluido);
                setqtdepremicaorankingconforme(response.data.qtdepremicaorankingconforme);
                setqtdepremicaorankingprazo(response.data.qtdepremicaorankingprazo);
                setqtdepremicaorankingavaliacao(response.data.qtdepremicaorankingavaliacao);
                setvalorpremiacaosetor(response.data.valorpremiacaosetor);
                setvalorpremiacaofuncao(response.data.valorpremiacaofuncao);
                setvalorpremiacaoequipe(response.data.valorpremiacaoequipe);
            })
            .catch(function (err) {
                console.log("ops! ocorreu um erro: " + err);
            });
    }

    useEffect(
        function () {
            ListarParametro();
        },
        [selectedCompany]
    );

    function Cadastrar() {
        api
            .post(
                "/v1/parametro",
                {
                    codparametro,
                    qtdefeedback,
                    valorcoinfeedbackpositivo,
                    valorcoinfeedbacknegativo,
                    excluido: "N",
                    codassinante,
                    codempresa: selectedCompany,
                    valorcoinrankingconcluido,
                    valorcoinrankingconforme,
                    valorcoinrankingprazo,
                    valorcoinrankingavaliacao,
                    qtdepremicaorankingconcluido,
                    qtdepremicaorankingconforme,
                    qtdepremicaorankingprazo,
                    qtdepremicaorankingavaliacao,
                    valorpremiacaosetor,
                    valorpremiacaofuncao,
                    valorpremiacaoequipe
                },
                {
                    headers: {
                        Authorization: `Bearer ${accessKey}`,
                    },
                }
            )
            .then(() => {
                alert("Parâmetro atualizado com sucesso!");
            })
            .catch(function (err) {
                console.log("ops! ocorreu um erro: " + err);
            });
    }

    return (
        <>
            <div className="app-container">
                <div className="container-fluid">
                    <div className="header">
                        <h1 className="ms-4">Configurações</h1>
                        <p className="ms-4">Rotina para configurar os parâmetros do sistema</p>
                        <hr />
                    </div>

                    <div className="body">
                        <h4>Feedback</h4>
                        <div className="row">
                            <div className="col-sm-3">
                                <label htmlFor="qtdefeedback" className="form-label">
                                    Quantidade
                                </label>
                                <input
                                    type="number"
                                    id="qtdefeedback"
                                    className="form-control"
                                    placeholder="Qtde. Feedback"
                                    value={qtdefeedback}
                                    onChange={(e) => setqtdefeedback(e.target.value)}
                                />
                            </div>

                            <div className="col-sm-3">
                                <label htmlFor="valorcoinfeedbackpositivo" className="form-label">
                                    Valor Coin Positivo
                                </label>
                                <input
                                    type="number"
                                    id="valorcoinfeedbackpositivo"
                                    className="form-control"
                                    placeholder="Valor Coin Feedback Positivo"
                                    value={valorcoinfeedbackpositivo}
                                    onChange={(e) => setvalorcoinfeedbackpositivo(e.target.value)}
                                />
                            </div>

                            <div className="col-sm-3">
                                <label htmlFor="valorcoinfeedbacknegativo" className="form-label">
                                    Valor Coin Negativo
                                </label>
                                <input
                                    type="number"
                                    id="valorcoinfeedbacknegativo"
                                    className="form-control"
                                    placeholder="Valor Coin Feedback Negativo"
                                    value={valorcoinfeedbacknegativo}
                                    onChange={(e) => setvalorcoinfeedbacknegativo(e.target.value)}
                                />
                            </div>
                        </div>

                        <hr />

                        <h4>Premiação Ranking Checklist</h4>
                        <div className="row">
                            <div className="col-sm-2">
                                <label htmlFor="valorcoinrankingconcluido" className="form-label">
                                    Valor Coin Concluído
                                </label>
                                <input
                                    type="number"
                                    id="valorcoinrankingconcluido"
                                    className="form-control"
                                    placeholder="Valor Coin Concluído"
                                    value={valorcoinrankingconcluido}
                                    onChange={(e) => setvalorcoinrankingconcluido(e.target.value)}
                                />
                            </div>

                            <div className="col-sm-1">
                                <label htmlFor="qtdepremicaorankingconcluido" className="form-label">
                                    Qtde Posição
                                </label>
                                <input
                                    type="number"
                                    id="qtdepremicaorankingconcluido"
                                    className="form-control"
                                    placeholder="Qtde Concluído"
                                    value={qtdepremicaorankingconcluido}
                                    onChange={(e) => setqtdepremicaorankingconcluido(e.target.value)}
                                />
                            </div>

                            <div className="col-sm-2">
                                <label htmlFor="valorcoinrankingconforme" className="form-label">
                                    Valor Coin Conforme
                                </label>
                                <input
                                    type="number"
                                    id="valorcoinrankingconforme"
                                    className="form-control"
                                    placeholder="Valor Coin Conforme"
                                    value={valorcoinrankingconforme}
                                    onChange={(e) => setvalorcoinrankingconforme(e.target.value)}
                                />
                            </div>

                            <div className="col-sm-1">
                                <label htmlFor="qtdepremicaorankingconforme" className="form-label">
                                    Qtde Posição
                                </label>
                                <input
                                    type="number"
                                    id="qtdepremicaorankingconforme"
                                    className="form-control"
                                    placeholder="Qtde Conforme"
                                    value={qtdepremicaorankingconforme}
                                    onChange={(e) => setqtdepremicaorankingconforme(e.target.value)}
                                />
                            </div>

                            <div className="col-sm-2">
                                <label htmlFor="valorcoinrankingprazo" className="form-label">
                                    Valor Coin Prazo
                                </label>
                                <input
                                    type="number"
                                    id="valorcoinrankingprazo"
                                    className="form-control"
                                    placeholder="Valor Coin Prazo"
                                    value={valorcoinrankingprazo}
                                    onChange={(e) => setvalorcoinrankingprazo(e.target.value)}
                                />
                            </div>

                            <div className="col-sm-1">
                                <label htmlFor="qtdepremicaorankingprazo" className="form-label">
                                    Qtde Posição
                                </label>
                                <input
                                    type="number"
                                    id="qtdepremicaorankingprazo"
                                    className="form-control"
                                    placeholder="Qtde Prazo"
                                    value={qtdepremicaorankingprazo}
                                    onChange={(e) => setqtdepremicaorankingprazo(e.target.value)}
                                />
                            </div>

                            <div className="col-sm-2">
                                <label htmlFor="valorcoinrankingavaliacao" className="form-label">
                                    Valor Coin Avaliação
                                </label>
                                <input
                                    type="number"
                                    id="valorcoinrankingavaliacao"
                                    className="form-control"
                                    placeholder="Valor Coin Feedback Positivo"
                                    value={valorcoinrankingavaliacao}
                                    onChange={(e) => setvalorcoinrankingavaliacao(e.target.value)}
                                />
                            </div>

                            <div className="col-sm-1">
                                <label htmlFor="qtdepremicaorankingavaliacao" className="form-label">
                                    Qtde Posição
                                </label>
                                <input
                                    type="number"
                                    id="qtdepremicaorankingavaliacao"
                                    className="form-control"
                                    placeholder="Qtde Avaliação"
                                    value={qtdepremicaorankingavaliacao}
                                    onChange={(e) => setqtdepremicaorankingavaliacao(e.target.value)}
                                />
                            </div>

                            <div className="col-sm-2">
                                <label htmlFor="valorpremiacaosetor" className="form-label">
                                    Valor Coin Setor
                                </label>
                                <input
                                    type="number"
                                    id="valorpremiacaosetor"
                                    className="form-control"
                                    placeholder="Valor Coin Setor"
                                    value={valorpremiacaosetor}
                                    onChange={(e) => setvalorpremiacaosetor(e.target.value)}
                                />
                            </div>

                            <div className="col-sm-2">
                                <label htmlFor="valorpremiacaofuncao" className="form-label">
                                    Valor Coin Função
                                </label>
                                <input
                                    type="number"
                                    id="valorpremiacaofuncao"
                                    className="form-control"
                                    placeholder="Valor Coin Função"
                                    value={valorpremiacaofuncao}
                                    onChange={(e) => setvalorpremiacaofuncao(e.target.value)}
                                />
                            </div>

                            <div className="col-sm-2">
                                <label htmlFor="valorpremiacaoequipe" className="form-label">
                                    Valor Coin Equipe
                                </label>
                                <input
                                    type="number"
                                    id="valorpremiacaoequipe"
                                    className="form-control"
                                    placeholder="Valor Coin Equipe"
                                    value={valorpremiacaoequipe}
                                    onChange={(e) => setvalorpremiacaoequipe(e.target.value)}
                                />
                            </div>
                        </div>
                        <hr />

                        <h4>Geral</h4>
                        <div className="row">
                            <div className="col-sm-3">
                                <label htmlFor="ativo1" className="form-label">
                                    Verificar Saldo do Orçamento
                                </label>
                                <br />
                                <div className="form-check form-check-inline">
                                    <input
                                        className="form-check-input"
                                        id="verificarorcamento"
                                        type="radio"
                                        name="verificarorcamento"
                                        value="S"
                                        onChange={(e) => setverificaorcamento(e.target.value)}
                                        checked={verificaorcamento === "S"}
                                    />
                                    <label className="form-check-label">Sim</label>
                                </div>

                                <div className="form-check form-check-inline">
                                    <input
                                        className="form-check-input"
                                        type="radio"
                                        name="verificarorcamento"
                                        value="N"
                                        onChange={(e) => setverificaorcamento(e.target.value)}
                                        checked={verificaorcamento === "N"}
                                    />
                                    <label className="form-check-label">Não</label>
                                </div>
                            </div>                            
                        </div>
                        <hr />
                    </div>

                    <div className="footer">
                        <div className="row">
                            <div className="col-sm-12 d-flex justify-content-end">
                                <button type="button" className="btn btn-success" onClick={Cadastrar}>Salvar</button>
                            </div>
                        </div>
                    </div>


                </div>
            </div>
        </>
    )
}


export default Configuracao;